import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
import { LanguageToggle } from './LanguageToggle';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const {
    t
  } = useLang();
  const links = [{
    href: '#servicios',
    label: t.nav.services
  }, {
    href: '#portafolio',
    label: t.nav.portfolio
  }, {
    href: '#nosotros',
    label: t.nav.about
  }, {
    href: '#resenas',
    label: t.nav.reviews
  }];
  return <nav className="fixed w-full z-50 bg-dark/90 backdrop-blur-md border-b border-white/10" data-id="element-308" data-mp="lpqk433sem2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-309" data-mp="ehb8xseu005i">
        <div className="flex justify-between items-center h-24" data-id="element-310" data-mp="9j9op45o5usg">
          <div className="flex-shrink-0 flex items-center" data-id="element-311" data-mp="1pyazojlj66xf">
            <img src="https://cdn.magicpatterns.com/uploads/evyospU31vfdfaKZswB6gc/Photoroom_20260524_142746.png" alt={t.footer.logoAlt} className="h-16 md:h-20 w-auto object-contain" data-id="element-312" data-mp="1pwq72zis0y27" />
          </div>

          <div className="hidden md:flex items-center space-x-8" data-id="element-313" data-mp="emrhs35h6wga">
            {links.map(link => <a key={link.href} href={link.href} className="text-gray-300 hover:text-gold transition-colors text-sm font-medium" data-id="element-314" data-mp="jmdumbhe6aok">
                {link.label}
              </a>)}
            <LanguageToggle data-id="element-315" data-mp="3n1j8f7e4tgvk" />
            <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="bg-gold text-dark px-6 py-2.5 rounded-full font-bold text-sm hover:bg-gold-400 transition-all transform hover:scale-105" data-id="element-316" data-mp="3s1xl52qohezx">
              {t.nav.cta}
            </a>
          </div>

          <div className="md:hidden flex items-center gap-3" data-id="element-317" data-mp="34as1sdlj44kv">
            <LanguageToggle data-id="element-318" data-mp="39ao8wlpiwc4n" />
            <button onClick={() => setIsOpen(!isOpen)} aria-label={isOpen ? t.nav.closeMenu : t.nav.openMenu} aria-expanded={isOpen} className="text-gray-300 hover:text-white" data-id="element-319" data-mp="399ux36bpiwfn">
              {isOpen ? <X className="h-6 w-6" data-id="element-320" data-mp="3b0jm5w956iq3" /> : <Menu className="h-6 w-6" data-id="element-321" data-mp="361ggc9lc88h2" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && <div className="md:hidden bg-dark-100 border-b border-white/10" data-id="element-322" data-mp="2iei4xqc2rqq0">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-323" data-mp="2devqjdkig4fm">
            {links.map(link => <a key={link.href} href={link.href} onClick={() => setIsOpen(false)} className="block px-3 py-2 text-gray-300 hover:text-gold font-medium" data-id="element-324" data-mp="2sc68n5rns8kb">
                {link.label}
              </a>)}
            <a href="https://wa.me/447311754270?text=WEBSITE" className="block px-3 py-2 text-gold font-bold" data-id="element-325" data-mp="2khubtyc69zy">
              {t.nav.cta}
            </a>
          </div>
        </div>}
    </nav>;
}